export default "__VITE_ASSET__CKtFheZ3__"